import { AdvancedMarker,APIProvider,Map } from '@vis.gl/react-google-maps';
import { useTranslation } from 'react-i18next';
import { trackEventMatomo } from '../../../helpers/matomo';
import { centerType } from '../../../types/reports/types';

export default function MapModal({ center, openMap, setOpenMap }: { center: centerType, openMap: boolean, setOpenMap: Function }) {
  const { t } = useTranslation('translation');
  return (
    <APIProvider apiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY || ''}>
      <div className={`modal ${openMap ? 'is-active' : ''}`}>
        <div className="modal-background"></div>
        <div className="modal-content">
          <button
            onClick={() => {
              trackEventMatomo('Modal mapa', 'click', 'button', 'fechar');
              setOpenMap(!openMap);
            }}
            className='button is-danger is-small'>
            {t('Reports.modalDetailP.close')}
          </button>
          <div style={{ height: '60svh' }}>
            <Map
              defaultCenter={center || 0}
              defaultZoom={18}
              mapId={process.env.REACT_APP_GOOGLE_MAPS_MAP_ID || ''}>
              <AdvancedMarker position={center || 0} />
            </Map>
          </div>
        </div>
      </div>
    </APIProvider>

  );
}
